import { add, format } from "date-fns";
import { useStore } from "./store.hooks";

export const useControleQuinquennal = () => {
  const storeValue = useStore();

  const { data, status, setData } = storeValue.controleQuinquennal;

  const setHasControleQuinquennal = (hasControl: boolean) =>
    setData({
      hasControlesQuinquennaux: hasControl,
      controlesQuinquennaux: data?.controlesQuinquennaux ?? [],
    });

  const getDateFinDepot = (
    dateCreation: Date,
    datePremiereRemediation: Date | null
  ) => {
    const dateFormat = "dd/MM/yyyy";
    if (datePremiereRemediation) {
      return format(
        add(new Date(datePremiereRemediation), {
          months: 2,
        }),
        dateFormat
      );
    }
    return format(add(new Date(dateCreation), { days: 21 }), dateFormat);
  };

  return {
    hasControlesQuinquennaux: data?.hasControlesQuinquennaux ?? false,
    controlesQuinquennaux: data?.controlesQuinquennaux ?? [],
    status,
    setHasControleQuinquennal,
    getDateFinDepot,
  };
};
